import React from 'react';
import LogoComponent from '../../components/LogoComponent';
import { MdSpaceDashboard } from "react-icons/md";
import { FaUsers, FaDollarSign, FaCrown, FaFileAlt } from "react-icons/fa";
import { PiVideoFill } from "react-icons/pi";

import { AiFillMessage } from "react-icons/ai";
import { IoSettingsSharp } from "react-icons/io5";
import { FaQuestionCircle } from "react-icons/fa";
import { Sidebar } from 'flowbite-react';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminSidebarMobile = ({ isSidebarOpen }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const style = {
        "root": {
            "base": "h-full",
            "collapsed": { "on": "w-16", "off": "w-64" },
            "inner": "h-full no-scrollbar overflow-y-auto overflow-x-hidden rounded-none bg-gray-50 py-4 px-3 border-r border-gray-200"
        }
    };

    const MenuItem = ({ icon: Icon, label, path, color = "text-gray-600" }) => {
        const active = location.pathname === path;
        return (
            <div
                onClick={() => navigate(path)}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer transition-all ${active ? 'bg-black text-white' : 'hover:bg-gray-100 text-gray-700'}`}
            >
                <Icon size={18} className={active ? 'text-white' : color} />
                <span className={`text-sm ${active ? 'font-bold' : 'font-medium'}`}>{label}</span>
            </div>
        );
    };

    const SectionLabel = ({ label }) => (
        <p className='text-xs font-bold text-gray-400 uppercase tracking-wider px-3 mt-6 mb-2'>{label}</p>
    );

    return (
        <Sidebar
            aria-label="Mobile sidebar"
            theme={style}
            className={`fixed inset-y-0 left-0 w-64 bg-gray-50 z-50 overflow-y-auto transition-transform transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
            <LogoComponent isDarkMode={false} />

            <div className='mt-6'>
                <MenuItem icon={MdSpaceDashboard} label="Dashboard" path="/admin" color="text-blue-500" />

                <SectionLabel label="Management" />
                <MenuItem icon={FaUsers} label="Users" path="/users" color="text-blue-500" />
                <MenuItem icon={PiVideoFill} label="Courses" path="/courses" color="text-purple-500" />
                <MenuItem icon={FaDollarSign} label="Paid Users" path="/paid" color="text-green-500" />
                <MenuItem icon={FaCrown} label="Admins" path="/admins" color="text-yellow-500" />
                <MenuItem icon={AiFillMessage} label="Contacts" path="/contacts" color="text-pink-500" />

                <SectionLabel label="Plans & Billing" />
                <MenuItem icon={FaDollarSign} label="Plans" path="/plans" color="text-green-500" />

                <SectionLabel label="Legal Pages" />
                <MenuItem icon={FaFileAlt} label="Terms" path="/editterms" color="text-gray-500" />
                <MenuItem icon={FaFileAlt} label="Privacy" path="/editprivacy" color="text-gray-500" />
                <MenuItem icon={FaFileAlt} label="Cancellation" path="/editcancellation" color="text-gray-500" />
                <MenuItem icon={FaFileAlt} label="Refund" path="/editrefund" color="text-gray-500" />
                <MenuItem icon={FaFileAlt} label="Billing Policy" path="/editbilling" color="text-gray-500" />

                <SectionLabel label="Configuration" />
                <MenuItem icon={IoSettingsSharp} label="Settings" path="/settings" color="text-gray-600" />
                <MenuItem icon={FaQuestionCircle} label="Guide" path="/guide" color="text-blue-400" />
            </div>
        </Sidebar>
    );
};

export default AdminSidebarMobile;
